import React from 'react';
import {
  Box,
  Paper,
  Avatar,
  Typography,
  Chip,
  ListSubheader,
  styled,
  alpha,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import {
  Groups as TeamsIcon,
  Work as PositionIcon,
  Badge as EmployeeIcon,
  Circle as StatusIcon,
  Person,
  PeopleAlt,
  Logout,
  LockClockOutlined,
  Timelapse,
  AccessTime
} from '@mui/icons-material';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';
import { mtDividerUpTable, paddingCardsTables } from '../../commons';
import { useDispatch, useSelector } from 'react-redux';
import { closeSessionGlobal, getHoursFromDate } from '../../commons/utils';
import { ModalSessionExpired } from '../../components/generics/ModalSessionExpired';
import { SnackAlert } from '../../components/SnackAlert';
import { getEmployeesInShift, outEmployeesInShift } from '../../store/control_tiempos';
import { AvatarTables } from '../../components/AvatarTables';
import { AvatarEmployeesInShift } from '../../components/AvatarEmployeesInShift';
// import { TimeClock } from '@mui/x-date-pickers';

// Datos de ejemplo
// const employees:any = [
//   { id: 1, name: 'Juan Pérez', position: 'Desarrollador', avatar: '/avatars/1.jpg', team: 'Frontend', status: 'active' },
//   { id: 2, name: 'María García', position: 'Diseñador', avatar: '/avatars/2.jpg', team: 'UX/UI', status: 'active' },
//   { id: 3, name: 'Carlos López', position: 'Desarrollador', avatar: '/avatars/3.jpg', team: 'Backend', status: 'vacation' },
//   { id: 4, name: 'Ana Martínez', position: 'Gerente', avatar: '/avatars/4.jpg', team: 'Gestión', status: 'active' },
//   { id: 5, name: 'Luisa Fernández', position: 'Diseñador', avatar: '/avatars/5.jpg', team: 'UX/UI', status: 'training' },
// ];

// Componente estilizado
const ElegantPaper = styled(Paper)(({ theme }) => ({
  width: '100%',
  maxWidth: 1200,
  borderRadius: '12px',
  overflow: 'hidden',
  boxShadow: theme.shadows[3],
  padding: '16px',
  
}));

const GroupHeader = styled(ListSubheader)(({ theme }) => ({
  backgroundColor: '#2E263D14', //alpha(theme.palette.primary.main, 0.9),
  color: theme.palette.primary.contrastText,
  fontSize: '0.95rem',
  fontWeight: 600,
  padding: '10px 16px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginTop: '16px',
  borderRadius: '6px',
  '&:first-of-type': {
    marginTop: 0
  }
}));

const EmployeeCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '12px',
  borderRadius: '8px',
  backgroundColor: alpha(theme.palette.background.paper, 0.7),
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  minWidth: '160px',
  marginRight: '12px',
  transition: 'all 0.2s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[2],
    backgroundColor: alpha(theme.palette.background.paper, 0.9),
  }
}));



const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center'
}));

export const ControlTiempos = () => {


  // DISPATCH
  const dispatch = useDispatch();
    
    
  // REDUX
  const { employeesInShiftList }:any  = useSelector( (state:any) => state.controlTiempos );
  
  const [employees, setEmployees] = React.useState([]);
  const [employeeId, setEmployeeId] = React.useState('');
  


  
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
  
  const [alert_snack, setAlertSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (id:string)  => {
    setEmployeeId(id)
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };



 // USE EFFECT 
  React.useEffect( () => {
      // HERE LOAD THE DATA FOR DATATABLE
      getDataEmployeesInShift();
  }, []);


  React.useEffect( () => {
    // HERE LOAD THE DATA FOR DATATABLE
    setEmployees(employeesInShiftList);
    
}, [employeesInShiftList]);


  const getDataEmployeesInShift = async() => {
    
        const response = await dispatch( getEmployeesInShift() );

        await validateResponse(response, ' (Listar Empleados) ');
  
  }


  const employeeOut = async() => {

    setOpen(false);
    const response = await dispatch( outEmployeesInShift(employeeId) );

    const result = await validateResponse(response, ' (Listar terminar turno) ');

    if (!result) {
      return false;
    }


    if (response.ok) {

      const errors:any = {
        msg: 'Salida correcta.',
        status: 'success'
      };
    
      await setMsgSnack(errors);
      await setAlertSnack(true);

    }

  }


  const validateResponse = async(response:any, textActionConcat: string) => {
  
  
        if (  response.code == 401  ) {
          await localStorage.removeItem('lastSelectedQypht');
          await closeSessionGlobal();
          setModalSessionExpired(true);
          return false;
        }

      
        // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
        if (!response.ok && response.code == 403 ) { 

        
          const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
          };
        
          await setMsgSnack(errors);
          await setAlertSnack(true);

        
          return false;
          
        }

        
        // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
        if (!response.ok && response.code == 400 ) { 

          const errors:any = [];

          response.errors.forEach( (element:any) => {
              
              errors.push({
                type: 'error',
                text: element
              })
          });

            
          setMessagesAlerts(errors);
          return false;

        }

        return true;
      
    }


  // Agrupar empleados por posición
  const groupedEmployees = employees.reduce((acc:any, employee:any) => {
    console.log(employee.empleado)
    const group = acc[employee.empleado.position.name] || [];
    return { ...acc, [employee.empleado.position.name]: [...group, employee] };
  }, {} as Record<string, typeof employees>);

  return (


    

    <>
    <BreadCrumbsAndTitle
                          title="Listado Control Tiempos" 
                          mainModule="configuracion" 
                          parent="Control Tiempos"
                          action="" />

    <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.controlTiempos} /> 
    <Divider sx={{ marginBottom: mtDividerUpTable }}/>

    <ModalSessionExpired  open={modalSessionExpired}  />
    <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>


    <div style={{marginTop: 50}}></div>

    {
       employees.length > 0
         ?
            <ElegantPaper>
            {Object.entries(groupedEmployees).map(([position, employees]:any) => (
              <Box key={position} sx={{ mb: 3 }}>
                <GroupHeader>
                  <PeopleAlt sx={{ fontSize: '18px', color: '#2e263de6' }} />
                  <Typography variant="h6" component="h2" sx={{ color: '#2e263de6'}}>
                      {position}
                  </Typography>
                  <Chip
                    label={`${employees.length}`} 
                    size="small"
                    sx={{
                      ml: 1,
                      color: 'inherit',
                      backgroundColor: '#2e263de6', //alpha('#fff', 0.2),
                      height: '22px',
                    }}
                  />
                </GroupHeader>
      
                <Box sx={{ 
                  display: 'flex',
                  overflowX: 'auto',
                  py: '8px',
                  '&::-webkit-scrollbar': {
                    height: '6px',
                  },
                  '&::-webkit-scrollbar-thumb': {
                    backgroundColor: alpha('#000', 0.2),
                    borderRadius: '3px',
                  }
                }}>
                  {employees.map((employee:any) => (
                    <EmployeeCard key={employee.id}>
                      <Logout sx={{ fontSize: '22px', mr: 0.5,   alignSelf: 'end', cursor: 'pointer' }} onClick={ () => handleClickOpen(employee.id)} />
                      <AvatarEmployeesInShift 
                         urlImage={employee.empleado.employee_avatar || 'default.png'} typeImage='image-employee' />
                      {/* <Avatar
                        alt={employee.name}
                        src={employee.empleado.employee_avatar}
                        sx={{
                          width: 56,
                          height: 56,
                          mb: 1,
                          border: `2px solid ${alpha('#fff', 0.8)}`,
                          boxShadow: 1
                        }}
                      /> */}
      
                      <Typography variant="subtitle2" fontWeight={500} textAlign="center">
                        {employee.empleado.name || 'N/A'}
                      </Typography>
      
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'center',
                        mt: 0.5,
                        mb: 1
                      }}>
                        <StatusIcon sx={{
                          color:
                            employee.llegada_tarde === 1 ? '#d4820e' :
                            employee.llegada_tarde === 0 ? '#44b700' :
                            '#44b700',
                          fontSize: '12px',
                          mr: 0.5
                        }} />
                        <Typography variant="caption" color="text.secondary">
                          { employee.llegada_tarde === 1 ?  'Tarde' : 'OK' }
                        </Typography>
                      </Box>
      
                      <Box sx={{ 
                        display: 'flex',
                        alignItems: 'center',
                        mb: 0.5
                      }}>
                        <EmployeeIcon sx={{ fontSize: '14px', mr: 0.5, color: 'action.active' }} />
                        <Typography variant="caption" color="text.secondary">
                          ID: {employee.empleado.document_number}
                        </Typography>
                      </Box>
      
                      <Box sx={{ 
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        <AccessTime sx={{ fontSize: '14px', mr: 0.5, color: 'action.active' }} />
                        <Typography variant="caption" color="text.secondary">
                          <strong>{getHoursFromDate(employee.hora_entrada)}</strong>
                        </Typography>
                        
                        
                      </Box>
                    </EmployeeCard>
                  ))}
                </Box>
              </Box>
            ))}
          </ElegantPaper>

          
         :
         <Div>{"No hay empleados en turno..."}</Div>
    }
    
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Desea sacar al empleado del turno?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            El empleado no ha  registrado la salida a la hora programada. 
            Por este motivo, procederemos a marcar la salida del sistema con base en el horario establecido.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button
                style={{margin:5, float: 'right'}}
                variant="contained"
                color={ "primary"}
                onClick={employeeOut}
              >
                Aceptar
            </Button>
          
        </DialogActions>
    </Dialog>

    </>
  );
}